import { render } from "./ModalMenu.vue?vue&type=template&id=ef225570&scoped=true"
import script from "./ModalMenu.vue?vue&type=script&lang=js"
export * from "./ModalMenu.vue?vue&type=script&lang=js"

import "./ModalMenu.vue?vue&type=style&index=0&id=ef225570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef225570"]])

export default __exports__